import styled, { css } from 'styled-components';
import { Label as Label$1 } from '../label/label.component.js';
import { marginStyles, formElementErrorStyles } from '../../styles/components.js';
import { addsMask } from '../../utils/color-manipulation.js';
import { mapBackgroundToContentColor } from '../../utils/color-mapper.js';
import 'react';

const Wrapper = styled.div `
  display: flex;
  align-items: flex-start;
  width: ${props => props.width};

  ${props => marginStyles(props.margin)};
`;
const focus = (props) => css `
    box-shadow: 0 0 0 2px
        ${mapBackgroundToContentColor({
    backgroundColor: 'primaryInverse',
    theme: props.theme,
})},
      0 0 0 4px ${props.theme.colors.background.primaryInverse};
    outline: transparent solid 2px;
  `;
const hover = (props) => css `
  background: ${addsMask({
    color: props.checked ? 'primaryInverse' : 'tertiary',
    isBackgroundColor: true,
    props,
})};
`;
const active = (props) => css `
  background: ${addsMask({
    color: props.checked ? 'primaryInverse' : 'tertiary',
    isBackgroundColor: true,
    lighten: true,
    props,
})};
`;
const Button = styled.button `
  height: 24px;
  width: 48px;
  min-width: 48px;
  border-radius: 12px;
  border: none;
  background: ${props => props.checked
    ? props.theme.colors.background.primaryInverse
    : props.theme.colors.background.tertiary};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${props => props.disabled ? props.theme.opacities.low : props.theme.opacities.high};

  ${formElementErrorStyles}

  &:focus {
    ${focus}
  }

  &:hover {
    ${hover}
  }

  &:active {
    ${active}
  }
`;
const Circle = styled.div `
  border-radius: ${props => props.theme.borderRadii.circular};
  z-index: 1;
  background: ${props => props.disabled && !props.checked
    ? props.theme.colors.content.secondary
    : props.theme.colors.content.primaryInverse};
  height: 16px;
  width: 16px;
  position: relative;
  left: ${props => (props.checked ? '20px' : 0)};
`;
const Label = styled(Label$1) `
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export { Button, Circle, Label, Wrapper };
